export default __webpack_public_path__ + "static/media/19_tag_paid-beauty-salon.0bb33572.svg";